import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const initI18n = async () => {
    await i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .use(Backend)
        .init({
            debug: process.env.NODE_ENV === "development",
            react: {
                useSuspense: false,
                wait: true,
            },
            lng: "en",
            fallbackLng: "en",
            returnObjects: true,
            interpolation: {
                // React already escapes rendered text, so let interpolated values
                // (e.g. URLs with slashes) through unescaped instead of as HTML entities.
                escapeValue: false,
            },
        });
};

initI18n();

export default i18n;
